// import axios from 'axios'I
export default {
    namespaced: true,
    state: {
        hold: false,
        secondParticipiant: false,
        secondParticipiantParams: null
    },
    getters: {
        hold: (state) => state.hold,
        secondParticipiant: (state) => state.secondParticipiant,
        secondParticipiantParams: (state) => state.secondParticipiantParams,
    },
    mutations: {
        SET_HOLD(state, hold) {
            state.hold = hold;
        },
        SOCKET_SET_SECOND_PARTICIPIANT_PARAMS(state, params) {
            state.secondParticipiantParams = params;
            state.secondParticipiant = !params ? false : true;
        },
        SET_SECOND_PARTICIPIANT(state, status) {
            state.secondParticipiant = status;
        }
    },
};
